import { useState } from "react";
import api from "@/services/api/admin/termTemplate";

const useModelTerm = () => {
	
    const [modelTermList, setModelTermList] = useState([])
    const [modelTermListLoading, setModelTermListLoading] = useState(false)
    const [modelTermListError, setModelTermListError] = useState(null)

    const fetchModelTermList = async() => {

        setModelTermListLoading(true);
        const [error, data] = await api.getModelTerms();
        setModelTermListLoading(false);
        
        if(error) {
            setModelTermListError(error)
        }

		setModelTermList(data ?? []);
	};

    
    return {
        modelTermList,
        fetchModelTermList,
        modelTermListLoading,
        modelTermListError,
    };
};

export default useModelTerm